import { useState, useEffect } from 'react';
import '../assets/styles/index.css';
import {
  Badge,
  Nav,
  NavDropdown,
  Container,
  Form,
} from 'react-bootstrap';
import {
  FaJenkins,
  FaUserLock,
  FaCartPlus,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SearchBox from './SearchBox';
import ThemeToggle from './ThemeToggle';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import { setCredentials } from '../slices/authSlice';
import { toast } from 'react-toastify';
import { useLoginMutation } from '../slices/usersApiSlice';
import { useTranslation } from 'react-i18next';
import { removeFromCartLocalStorage } from '../slices/cartSlice';
import { setCredentialLangue } from '../slices/langueSlice';
import { setCredentialDevise } from '../slices/deviseSlice';

const HeaderDesktop = () => {
  const [colorFormationPresential, setColorFormationPresential] = useState(
    'formation_presential_green'
  );
  const [colorFormationEnLigne, setColorFormationEnLigne] = useState(
    'formation_EnLigne_purple'
  );
  const [colorAutreProduit, setColorAutreProduit] = useState(
    'autre_produit_purple'
  );
  const [colorPanier, setColorPanier] = useState('panier_red');
  const [colorAuthentificationUser, setColorAuthentificationUser] = useState(
    'colorAuthentificationUser_green'
  );

  const { cartItems } = useSelector((state) => state.cart);
  const [email, setEmail] = useState('user@user');
  const [password, setPassword] = useState('user');
  const [login] = useLoginMutation();
  const { userInfo } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const { langueInfo } = useSelector((state) => state.langue);
  const { deviseInfo } = useSelector((state) => state.devise);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    if (userInfo) {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_green');
      setColorAuthentificationUser('colorAuthentificationUser_red');
    } else {
      setColorPanier('panier_red');
      setColorAuthentificationUser('colorAuthentificationUser_green');
    }
  }, [userInfo]);

  const connexion_invite = async () => {
    try {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_green');
      setEmail('user@user');
      setPassword('user');
      const res = await login({ email, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      navigate(redirect);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const changement_type_produit = async (type) => {
    try {
      if (type === 1) {
        setColorFormationEnLigne('formation_presential_green');
        setColorFormationPresential('formation_presential_purple');
        setColorAutreProduit('autre_produit_purple');
      } else if (type === 2) {
        setColorFormationEnLigne('formation_presential_purple');
        setColorFormationPresential('formation_presential_purple');
        setColorAutreProduit('autre_produit_green');
      } else if (type === 0) {
        setColorFormationEnLigne('formation_presential_purple');
        setColorFormationPresential('formation_presential_green');
        setColorAutreProduit('autre_produit_purple');
      }
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_red');
      setColorAuthentificationUser('colorAuthentificationUser_green');
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(removeFromCartLocalStorage());
      navigate('/');
    } catch (err) {
      console.log(err);
    }
  };

  const accountMenu = (
    <>
      {!userInfo && (
        <button type='button' className='nav-icon-btn' onClick={connexion_invite} title={t('guest')}>
          <FaJenkins />
        </button>
      )}

      {userInfo &&
        userInfo.name === 'User' &&
        !userInfo.isAdmin &&
        !userInfo.isOffice &&
        !userInfo.isFormateur &&
        !userInfo.isVendeur && (
          <NavDropdown title={userInfo.name} id='username' className='nav-account'>
            <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
          </NavDropdown>
        )}

      {userInfo &&
        userInfo.name !== 'User' &&
        !userInfo.isAdmin &&
        !userInfo.isOffice &&
        !userInfo.isFormateur &&
        !userInfo.isVendeur && (
          <NavDropdown title={userInfo.name} id='username' className='nav-account'>
            <NavDropdown.Item as={Link} to='/profile'>
              {t('Profile')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/my-courses'>
              Mes Formations
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/my-orders'>
              Mes Commandes
            </NavDropdown.Item>
            <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
          </NavDropdown>
        )}

      {userInfo &&
        userInfo.isAdmin &&
        !userInfo.isOffice &&
        !userInfo.isFormateur &&
        !userInfo.isVendeur && (
          <NavDropdown title='Admin' id='adminmenu' className='nav-account'>
            <NavDropdown.Item as={Link} to='/admin/productlist'>
              {t('products')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/orders'>
              Commandes (Admin)
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/click2paytable'>
              clic2pay Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/Paypaltable'>
              Paypal Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/Stripetable'>
              Stripe Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/userlist'>
              {t('users')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/cert'>
              Certificate Generator
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/verifycert'>
              Certificate Verification
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/meetings'>
              Meet
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/admin/playlist'>
              Playlist
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/profile'>
              {t('Profile')}
            </NavDropdown.Item>
            <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
          </NavDropdown>
        )}

      {userInfo &&
        !userInfo.isAdmin &&
        !userInfo.isFormateur &&
        !userInfo.isVendeur &&
        userInfo.isOffice && (
          <NavDropdown title='Office' id='officemenu' className='nav-account'>
            <NavDropdown.Item as={Link} to='/office/productlist'>
              {t('products')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/cert'>
              Certificate Generator
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/verifycert'>
              Certificate Verification
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/orderlist'>
              {t('orders')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/click2paytable'>
              clic2pay Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/Paypaltable'>
              Paypal Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/office/Stripetable'>
              Stripe Table
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/profile'>
              {t('Profile')}
            </NavDropdown.Item>
            <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
          </NavDropdown>
        )}

      {userInfo &&
        !userInfo.isAdmin &&
        !userInfo.isVendeur &&
        !userInfo.isOffice &&
        userInfo.isFormateur && (
          <NavDropdown title='Formateur' id='formateurmenu' className='nav-account'>
            <NavDropdown.Item as={Link} to='/formateur/productlist'>
              {t('products')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/formateur/playlist'>
              Playlists
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/formateur/meet'>
              Meet
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/profile'>
              {t('Profile')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/formateur/orders'>
              Mes Ventes
            </NavDropdown.Item>
            <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
          </NavDropdown>
        )}

      {userInfo && !userInfo.isAdmin && userInfo.isVendeur && (
        <NavDropdown title='Vendeur' id='vendeurmenu' className='nav-account'>
          <NavDropdown.Item as={Link} to='/vendeur/productlist'>
            {t('products')}
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to='/profile'>
            {t('Profile')}
          </NavDropdown.Item>
          <NavDropdown.Item onClick={logoutHandler}>{t('Logout')}</NavDropdown.Item>
        </NavDropdown>
      )}
    </>
  );

  return (
    <header>
      <Container fluid='xl' className={`nav-bar nav-lang-${(i18n.language || 'fr').split('-')[0]}`}>
        <Link to='/' className='header-brand'>
          <img src='/licorne.png' alt='Licorne Academy' />
          <div className='header-brand-text'>
            <strong>Licorne</strong>
            <span>Professional Academy</span>
          </div>
        </Link>

        <nav className='catalog-tabs'>
          <NavDropdown
            title={t('navProduct')}
            id='product-nav-dropdown'
            className={`product-dropdown ${
              colorFormationPresential.includes('green') ||
              colorFormationEnLigne.includes('green') ||
              colorAutreProduit.includes('green')
                ? 'product-dropdown-active'
                : ''
            }`}
          >
            <NavDropdown.Item
              as={Link}
              to='/'
              className={colorFormationPresential}
              onClick={() => changement_type_produit(0)}
            >
              {t('navInperson')}
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to='/online'
              className={colorFormationEnLigne}
              onClick={() => changement_type_produit(1)}
            >
              {t('navOnline')}
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to='/other'
              className={colorAutreProduit}
              onClick={() => changement_type_produit(2)}
            >
              {t('navOther')}
            </NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title={t('navCategory')} id='basic-nav-dropdown' className='category-dropdown'>
            <NavDropdown.Header>{t('presentielCategories')}</NavDropdown.Header>
            <NavDropdown.Item as={Link} to='/category/presentiel/info'>
              {t('info')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/category/presentiel/devp'>
              {t('devp')}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Header>{t('onlineCategories')}</NavDropdown.Header>
            <NavDropdown.Item as={Link} to='/category/online/info'>
              {t('info')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/category/online/devp'>
              {t('devp')}
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Header>{t('otherCategories')}</NavDropdown.Header>
            <NavDropdown.Item as={Link} to='/category/other/info'>
              {t('info')}
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to='/category/other/devp'>
              {t('devp')}
            </NavDropdown.Item>
          </NavDropdown>
        </nav>

        <div className='header-search'>
          <SearchBox />
        </div>

        <div className='nav-tools'>
          <Form.Control
            as='select'
            className='header-select'
            value={typeof langueInfo === 'string' ? langueInfo : 'fr'}
            onChange={(e) => {
              dispatch(setCredentialLangue(e.target.value));
              changeLanguage(e.target.value);
            }}
            aria-label={t('language')}
          >
            <option value='fr'>FR</option>
            <option value='en'>EN</option>
            <option value='ar'>AR</option>
          </Form.Control>

          <Form.Control
            as='select'
            className='header-select'
            value={typeof deviseInfo === 'string' ? deviseInfo : 'EUR'}
            onChange={(e) => dispatch(setCredentialDevise(e.target.value))}
            aria-label={t('devise')}
          >
            <option value='EUR'>EUR</option>
            <option value='USD'>USD</option>
          </Form.Control>

          <ThemeToggle />

          <Nav.Link as={Link} to='/cart' className={`cart-link ${colorPanier}`}>
            <FaCartPlus />
            {cartItems.length > 0 && (
              <Badge pill bg='success'>
                {cartItems.reduce((a, c) => a + c.qty, 0)}
              </Badge>
            )}
          </Nav.Link>

          <Nav.Link
            as={Link}
            to='/login'
            className={`nav-login ${colorAuthentificationUser}`}
            title={t('user')}
          >
            <FaUserLock />
          </Nav.Link>

          {accountMenu}
        </div>
      </Container>
    </header>
  );
};

export default HeaderDesktop;
